import type { ReusableContentStoryblok } from "@/types/storyblok-blok-types";

import { ReusableUI } from "./UI";

const Reusable = ({ blok }: { blok: ReusableContentStoryblok }) => {
  return <ReusableUI blok={blok} />;
};

export default Reusable;
